import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d158300"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layout"
};
const _hoisted_2 = {
  class: "mobile-header"
};
const _hoisted_3 = {
  class: "pc-sidebar"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sidebar-logo"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "logo-icon"
}, "♪"), /*#__PURE__*/_createElementVNode("span", {
  class: "logo-text"
}, "网易云音乐")], -1));
const _hoisted_5 = {
  class: "sidebar-nav"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发现音乐", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "热门歌曲", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索", -1));
const _hoisted_9 = {
  class: "main-content"
};
const _hoisted_10 = {
  class: "mobile-tabbar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_router_view = _resolveComponent("router-view");
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
  const _component_van_tabbar = _resolveComponent("van-tabbar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createVNode(_component_van_nav_bar, {
    "left-text": "网易云音乐",
    fixed: "",
    style: _normalizeStyle({
      '--van-nav-bar-background': 'var(--theme-primary)',
      '--van-nav-bar-text-color': '#fff',
      '--van-nav-bar-title-text-color': '#fff'
    })
  }, null, 8, ["style"])]), _createElementVNode("aside", _hoisted_3, [_hoisted_4, _createElementVNode("nav", _hoisted_5, [_createVNode(_component_router_link, {
    to: "/layout/home",
    class: _normalizeClass(["nav-item", {
      active: $options.activeRoute === '/layout/home'
    }])
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "home-o",
      size: "18"
    }), _hoisted_6]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_router_link, {
    to: "/layout/hot",
    class: _normalizeClass(["nav-item", {
      active: $options.activeRoute === '/layout/hot'
    }])
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "fire-o",
      size: "18"
    }), _hoisted_7]),
    _: 1
  }, 8, ["class"]), _createVNode(_component_router_link, {
    to: "/layout/search",
    class: _normalizeClass(["nav-item", {
      active: $options.activeRoute === '/layout/search'
    }])
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "search",
      size: "18"
    }), _hoisted_8]),
    _: 1
  }, 8, ["class"])])]), _createElementVNode("main", _hoisted_9, [_createVNode(_component_router_view)]), _createElementVNode("footer", _hoisted_10, [_createVNode(_component_van_tabbar, {
    modelValue: $data.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.active = $event),
    router: "",
    "active-color": "var(--theme-primary)"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
      replace: "",
      to: "/layout/home",
      icon: "home-o"
    }, {
      default: _withCtx(() => [_createTextVNode(" 推荐 ")]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      to: "/layout/hot",
      icon: "fire-o"
    }, {
      default: _withCtx(() => [_createTextVNode(" 热歌 ")]),
      _: 1
    }), _createVNode(_component_van_tabbar_item, {
      replace: "",
      to: "/layout/search",
      icon: "search"
    }, {
      default: _withCtx(() => [_createTextVNode(" 搜索 ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])])]);
}